/* src/app/cart/address-container/address/address.component.scss */
@media only screen and (max-width: 540px) {
  ion-list {
    height: 800px;
  }
}
.container {
  gap: 20px;
}
h2 {
  color: #949494;
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.gap-15 {
  gap: 15px;
}
.billing-header ion-icon {
  font-size: 35px;
  min-width: 35px;
  margin-right: 15px;
}
ion-button {
  margin: 0;
}
ion-button.add-data::part(native) {
  padding: 14px 18px;
}
ion-button[fill=clear] {
  min-height: 0;
  --border-radius: 0;
  color: black;
}
ion-button[fill=clear]::part(native) {
  padding: 0;
}
ion-button[fill=clear] ion-icon {
  font-size: 24px;
}
form {
  gap: 20px;
}
ion-input {
  height: 20px;
}
.email-message {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.body {
  white-space: pre-line;
  font-size: 14px;
  font-weight: 400;
}
h1 {
  font-size: 32px;
  font-weight: 600;
  font-family: Raleway;
  font-style: normal;
  line-height: normal;
}
ion-label,
.form-label {
  border: none;
  padding: 0;
  font-size: 20px !important;
  font-weight: 500 !important;
  margin: 0;
  margin-bottom: 10px !important;
  line-height: normal;
}
ion-label > span,
.form-label > span {
  color: #eb445a;
  font-size: 20px;
}
ion-input {
  border: 1px solid #949494;
  border-radius: 10px;
}
ion-input ::ng-deep .native-input {
  padding: 16px 10px 16px 10px !important;
}
ion-input ::ng-deep .native-input::placeholder {
  font-size: 18px;
  font-weight: 400;
}
ion-checkbox {
  --border-color: #949494;
  --border-radius: 5px;
  --size: 20px;
  color: #000;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: unset;
}
ion-checkbox span {
  color: #949494;
}
ion-checkbox::part(label) {
  text-wrap-mode: wrap;
}
#save-button ion-icon {
  font-size: 24px;
  margin: 0;
}
.save-button-container ion-button {
  min-height: 0;
  --border-radius: 10px;
  margin: 0;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-weight: 500;
}
.save-button-container ion-button::part(native) {
  padding: 14px 18px;
}
.save-button-container ion-button ion-icon {
  font-size: 24px;
}
@media (max-width: 768px) {
  h1 {
    font-size: 24px;
  }
  ion-label {
    font-size: 16px !important;
  }
  ion-input::ng-deep .native-input::placeholder {
    font-size: 16px;
  }
}
@media (max-width: 470px) {
  .billing-header ion-button ion-icon {
    width: 20px;
    height: 20px;
  }
  h2 {
    font-size: 24px !important;
  }
  .form-label {
    font-size: 16px !important;
  }
  ion-checkbox {
    font-size: 14px;
  }
  ion-button.add-data::part(native) {
    padding: 12px 16px;
  }
}
label span {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
label span.bold-span {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: black !important;
}
input[type=text] {
  padding: 16px 10px;
  border-radius: 10px;
  border: 1px solid #949494;
  color: black;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
input[type=text]::placeholder {
  color: #949494;
}
input[type=radio] {
  box-sizing: border-box;
  background-color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  appearance: none;
  background-color: transparent;
  outline: none;
  position: relative;
  cursor: pointer;
}
input[type=radio]::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #949494;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
input[type=radio]:checked::before {
  border: 5px solid #43c0f6;
}
input[type=radio]:disabled {
  opacity: 0.3;
}
.edit-address-button {
  background: none;
  outline: none;
  border: none;
  color: #0c8ce9;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  padding: 0 0 5px 0;
  border-bottom: 1px solid #0c8ce9;
  border-radius: 0px;
}
.edit-address-button:hover {
  opacity: 0.8;
}
.edit-address-button:active {
  opacity: 0.6;
}
/*# sourceMappingURL=address.component-O43KQDNG.css.map */
